// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3C-4A","footer":"ModalError_footer__y-OKI"};